export default __webpack_public_path__ + "static/media/Backward.6f53313a.svg";